import React from 'react';
import { CTAButton } from './ui/CTAButton';
import { ShieldCheckIcon, LockIcon, CreditCardIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="pt-16 pb-8 md:pt-28 md:pb-16 px-4 bg-white text-center" data-id="element-165">
      <div className="max-w-4xl mx-auto" data-id="element-166">
        <div className="inline-block bg-brand-light text-brand-blue font-bold px-4 py-1 rounded-full mb-6 border border-brand-blue/20" data-id="element-167">
          ⚡ FÍSICA EN ACCIÓN
        </div>

        <h1 className="text-3xl md:text-5xl font-black text-brand-dark mb-1 leading-tight tracking-tight" data-id="element-168">
          <span className="text-brand-blue" data-id="element-169">Física en Acción</span>
          <br data-id="element-170" />
          Todo tu año{' '}
          <span className="underline decoration-brand-orange decoration-4 md:decoration-8 underline-offset-4 md:underline-offset-8" data-id="element-171">
            resuelto.
          </span>
        </h1>

        <a href="#compra" className="block cursor-pointer transform hover:scale-[1.02] transition-transform duration-300 mb-4 md:mb-6 -mt-2" data-id="element-172">
          <img src="https://cdn.magicpatterns.com/uploads/4g1vtJvQmrf2cDKbJQ4uCq/Diseno_sin_titulo_(3).jpg" alt="MegaPack Física en Acción" className="w-full max-w-xl mx-auto drop-shadow-2xl rounded-xl" data-id="element-173" />
        </a>

        <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-4" data-id="element-174">
          FÍSICA EN ACCIÓN — 7 Tomos + 3 Bonos + Bóveda VIP
        </h2>

        <p className="text-xl md:text-2xl italic text-gray-600 font-medium mb-5 md:mb-8" data-id="element-175">
          "Planificación total. De 1° a 6° año. Con proyectos de Feria de
          Ciencias incluidos."
        </p>

        <p className="text-lg md:text-xl text-gray-700 max-w-3xl mx-auto mb-6 md:mb-10 leading-relaxed" data-id="element-176">
          El sistema que usan los profesores de Física de secundaria en
          Argentina para organizar sus clases de todo el ciclo básico y superior
          en una tarde — sin improvisar, sin buscar fórmulas en Google y
          recuperando sus domingos.
        </p>

        <div className="flex flex-wrap justify-center gap-3 md:gap-4 mb-6 md:mb-10" data-id="element-177">
          <span className="flex items-center gap-2 bg-gray-100 px-4 py-2 rounded-lg font-semibold text-gray-800" data-id="element-178">
            📄 100% PDF
          </span>
          <span className="flex items-center gap-2 bg-gray-100 px-4 py-2 rounded-lg font-semibold text-gray-800" data-id="element-179">
            ⚡ Acceso inmediato
          </span>
          <span className="flex items-center gap-2 bg-gray-100 px-4 py-2 rounded-lg font-semibold text-gray-800" data-id="element-180">
            🇦🇷 Diseño Curricular NAP Argentina 2026
          </span>
        </div>

        <div className="max-w-2xl mx-auto mb-6" data-id="element-181">
          <CTAButton text="⚗️ → QUIERO MI MEGAPACK AHORA" href="#compra" isLink={true} data-id="element-182" />
        </div>

        <div className="flex flex-wrap justify-center items-center gap-6 text-sm md:text-base text-gray-600 font-medium" data-id="element-183">
          <span className="flex items-center gap-1" data-id="element-184">
            <ShieldCheckIcon className="w-5 h-5 text-brand-green" data-id="element-185" /> Garantía 7
            días sin preguntas
          </span>
          <span className="flex items-center gap-1" data-id="element-186">
            <LockIcon className="w-5 h-5 text-gray-500" data-id="element-187" /> Pago 100% seguro —
            Mercado Pago
          </span>
        </div>
      </div>
    </section>;
}